{
  "accept": "قبول",
  "action": "الإجراء",
  "allCountries": "كل الدول",
  "allPayments": "كل طرق الدفع",
  "allTypes": "كل الأنواع",
  "amount": "المبلغ",
  "asset": "الأصل",
  "buy": "شراء",
  "buyer": "المشتري",
  "cancel": "إلغاء",
  "cancelFailed": "فشل الإلغاء",
  "cancelled": "ملغي",
  "completed": "مكتمل",
  "country": "الدولة",
  "createP2pAd": "إنشاء إعلان P2P",
  "dispute": "نزاع",
  "disputeReason": "سبب النزاع",
  "escrow": "الضمان",
  "escrowActive": "الضمان نشط",
  "escrowProtection": "حماية الضمان",
  "escrowReady": "الضمان جاهز",
  "fillAllFields": "املأ جميع الحقول",
  "global": "عالمي",
  "globalP2pTrading": "تداول P2P عالمي",
  "inEscrow": "في الضمان",
  "inTrade": "قيد التداول",
  "liveGlobalAds": "الإعلانات العالمية المباشرة",
  "loading": "جاري التحميل...",
  "markPaid": "تحديد كمدفوع",
  "noP2pAdsFound": "لا توجد إعلانات P2P.",
  "offline": "غير متصل",
  "online": "متصل",
  "open": "مفتوح",
  "openDispute": "فتح نزاع",
  "orderCancelledRefunded": "تم إلغاء الأمر وإرجاع الأصل",
  "orderDetails": "تفاصيل الطلب",
  "orderId": "معرف الطلب",
  "p2pOrderCreated": "تم إنشاء أمر P2P",
  "p2pSecurity": "أمان P2P",
  "p2pSecurity1": "✅ تداول بين المستخدمين",
  "p2pSecurity2": "✅ أوامر مباشرة من قاعدة البيانات",
  "p2pSecurity3": "✅ تتبع حالة الضمان",
  "p2pSecurity4": "✅ رفع إثبات الدفع",
  "p2pSecurity5": "✅ يمكن للإدارة مراجعة الكل",
  "p2pSecurity6": "✅ مسار آمن لحالة P2P",
  "p2pSubtitle": "اشترِ وبِع العملات الرقمية عالمياً مع حماية الضمان الآمن.",
  "p2pTitle": "تداول P2P العالمي",
  "payment": "الدفع",
  "paymentMethod": "طريقة الدفع",
  "paymentProof": "إثبات الدفع",
  "paymentSent": "تم إرسال الدفع",
  "paymentSubmitted": "تم إرسال الدفع",
  "pleaseLoginFirst": "يرجى تسجيل الدخول أولاً.",
  "price": "السعر",
  "processing": "جاري المعالجة...",
  "release": "إطلاق",
  "releaseFailed": "فشل الإطلاق",
  "selectPaymentMethod": "اختر طريقة الدفع",
  "sell": "بيع",
  "seller": "البائع",
  "serverError": "خطأ في الخادم.",
  "sessionExpired": "انتهت الجلسة. الرجاء تسجيل الدخول مرة أخرى.",
  "status": "الحالة",
  "totalOrders": "إجمالي الأوامر",
  "tradeCompletedSuccessfully": "اكتملت الصفقة بنجاح",
  "tradeFailed": "فشلت الصفقة",
  "tradeStartedSuccessfully": "بدأت الصفقة بنجاح",
  "trader": "المتداول",
  "unknownTrader": "تاجر",
  "uploadPaymentProof": "يرجى رفع صورة إثبات الدفع",
  "uploadProof": "رفع الإثبات",
  "verifiedMerchant": "تاجر موثق",
  "waitingEscrow": "بانتظار الضمان",
  "walletAddress": "عنوان المحفظة"
}